import React, { FC } from 'react';
import {
    Platform,
    Text as RNText,
    TextInput as RNTextInput,
    TextProps as RNTextProps,
} from 'react-native';
import { withIAPContext } from 'react-native-iap';

import View from './View';
import { useViewModel } from './viewModel';
import Screen from '../navigation/components/ApplicationScreen';
import type { MainProps } from './types';

const MAX_FONT_SIZE_MULTIPLIER = 1.3;
interface TextProps extends RNTextProps {
    defaultProps?: {
        allowFontScaling?: boolean;
        maxFontSizeMultiplier?: number;
    };
}
(RNText as TextProps).defaultProps = {
    ...((RNText as TextProps).defaultProps || {}),
    allowFontScaling: true,
    maxFontSizeMultiplier: MAX_FONT_SIZE_MULTIPLIER,
};

(RNTextInput as TextProps).defaultProps = {
    ...((RNTextInput as TextProps).defaultProps || {}),
    allowFontScaling: true,
    maxFontSizeMultiplier: MAX_FONT_SIZE_MULTIPLIER,
};

const Main: FC<MainProps> = (props) => {
    const viewModelProps = useViewModel(props);
    return <View {...viewModelProps} />;
};
Main.displayName = 'ApplicationMain';

const Application = {
    Main: ['ios', 'android'].includes(Platform.OS) && withIAPContext ? withIAPContext(Main) : Main,
    View,
    useViewModel,
    Screen,
};

export default Application;
